module.exports = __webpack_public_path__ + "static/media/addLogEntryHover.7d959268.png";